import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86414a00"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "exhibitions_current_item__container",
  "data-reveal-on-scroll": ""
}
const _hoisted_2 = { class: "exhibition_item__header" }
const _hoisted_3 = { class: "exhibition_item__dates" }
const _hoisted_4 = { class: "exhibition_item__title" }
const _hoisted_5 = { class: "exhibition_item__subtitle" }
const _hoisted_6 = { class: "exhibition_item__introduction" }
const _hoisted_7 = {
  key: 0,
  class: "exhibition_item__readmore_button"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "exhibitions_archive__container" }
const _hoisted_10 = { class: "exhibitions_archive__title" }
const _hoisted_11 = { class: "exhibitions_archive__introduction" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _component_page_section = _resolveComponent("page-section")!
  const _component_Slider = _resolveComponent("Slider")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createVNode(_component_page_section, {
          class: "exhibitions_current_item",
          backgroundColor: _ctx.backgroundColor || null
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(item.date) + " ", 1),
                  (item.date2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_Icon, {
                          type: "arrow-right",
                          class: "exhibition_item__dates__arrow"
                        }),
                        _createTextVNode(" " + _toDisplayString(item.date2), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h3", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.subtitle), 1),
                  _createTextVNode(" " + _toDisplayString(item.title), 1)
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
                [_directive_sanitize, item.introduction]
              ]),
              (item.link)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_ButtonLink, {
                      href: item.link,
                      label: "Meer informatie",
                      fontweight: "regular"
                    }, null, 8, ["href"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["backgroundColor"]),
        (item.images)
          ? (_openBlock(), _createBlock(_component_page_section, {
              key: 0,
              class: "exhibition_item__images",
              backgroundColor: _ctx.backgroundColor || null,
              revealOnScroll: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (image, imageindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "exhibition_item__image",
                    key: `imageindex-${imageindex}`
                  }, [
                    (imageindex < 3)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: image.src
                        }, null, 8, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["backgroundColor"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.showArchived)
      ? (_openBlock(), _createBlock(_component_page_section, {
          key: 0,
          class: "exhibitions_archive__introduction",
          backgroundColor: _ctx.backgroundColor || null,
          revealOnScroll: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.archiveTitle), 1),
              _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                [_directive_sanitize, _ctx.archiveText]
              ])
            ])
          ]),
          _: 1
        }, 8, ["backgroundColor"]))
      : _createCommentVNode("", true),
    (_ctx.showArchived)
      ? (_openBlock(), _createBlock(_component_page_section, {
          key: 1,
          class: "exhibitions_archive__items",
          backgroundColor: _ctx.backgroundColor || null,
          revealOnScroll: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Slider, {
              showSlideCount: false,
              class: "exhibitions_archive__items_slider",
              slides: _ctx.archivedItems,
              startAt: 0
            }, null, 8, ["slides"])
          ]),
          _: 1
        }, 8, ["backgroundColor"]))
      : _createCommentVNode("", true)
  ], 64))
}